import type { ReactNode } from "react";
import { GoogleAnalytics } from "./google";
import { keys } from "./keys";
import { ConversationsVisibility } from "./posthog/ConversationsVisibility";
import { PostHogProvider } from "./posthog/client";
import { VercelAnalytics } from "./vercel";

// Export PostHog client and hooks
export { analytics } from "./posthog/client";
// Export event tracking functions
export * from "./posthog/events";
export { usePostHogIdentify } from "./posthog/usePostHogIdentify";

type AnalyticsProviderProps = {
	readonly children: ReactNode;
};

const { NEXT_PUBLIC_GA_MEASUREMENT_ID } = keys();

export const AnalyticsProvider = ({ children }: AnalyticsProviderProps) => (
	<PostHogProvider>
		{children}
		<ConversationsVisibility />
		<VercelAnalytics />
		{NEXT_PUBLIC_GA_MEASUREMENT_ID && (
			<GoogleAnalytics gaId={NEXT_PUBLIC_GA_MEASUREMENT_ID} />
		)}
	</PostHogProvider>
);
